import React, { useState } from 'react';
import Table from './table';

const Tabs = ({ tabs }) => {
    const [activeTab, setActiveTab] = useState(tabs[0].id);

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    return (
        <div>
            <div className="flex justify-center w-full">
                {tabs.map((tab, index) => (
                    <div
                        key={index}
                        onClick={() => handleTabClick(tab.id)}
                        className={`cursor-pointer px-4 py-2 border-b-2 text-xl font-semibold ${activeTab === tab?.id ? 'border-gray-500 text-gray-500' : 'border-gray-300'
                            }`}
                    >
                        {tab.label}
                    </div>
                ))}
            </div>
            <div className='w-full px-4 flex justify-center'>
                {tabs.map((tab, index) => (
                    <div
                        key={tab.id + index}
                        className={`mt-4 ${activeTab === tab.id ? 'block' : 'hidden'}`}
                    >
                        <Table data={tab.content} />
                    </div>
                ))}
            </div>
            {/* {activeTab === 'Classes' && } */}
            {activeTab === 'Classes' &&
                <div className='flex flex-col gap-2 items-center text-start justify-center w-full p-4'>
                    {/* <div className='text-start'>
                        <h2 className='font-bold text-lg'>Classes</h2>
                        <div className='flex flex-col py-2 gap-1'>
                            <p>At <span className='font-bold'>ANHS</span>, our small-group classes are designed to create an engaging and focused learning environment.</p>
                            <p>Each class brings together students who share the <span className='font-bold'>same school</span> and
                            <span className='font-bold'> grade level</span>, ensuring that everyone <br />follows a similar curriculum and learns at the same pace.
                            </p>
                        </div>
                    </div> */}
                    <div className='text-start'>
                        <h2 className='font-bold text-md'>Class Requirements</h2>
                        <ul className='list-disc list-inside px-4'>
                            <li>Students must be from the <span className='font-bold'>same school</span> and <span className='font-bold'>same grade.</span></li>
                            <li>Each class includes a <span className='font-bold'>minimum of 2 students</span> and a <span className='font-bold'>maximum of 4 students.</span></li>                            
                            <li className='text-red-500 font-semibold'>Payments are due at the beginning of each month.</li>
                        </ul>
                    </div>
                    {/* <div className='text-start'>
                        <p><span className='font-bold'>Note:</span> This structure allows every student to receive personal attention while still<br /> benefiting from group collaboration.</p>
                    </div> */}
                </div>}
            
        </div>
    );
};

export default Tabs